/**
 * TanStack Query hooks for `igaming-chargeback-deduction-from-affiliate-commission`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingChargebackDeductionFromAffiliateCommissionQueryKeys,
	type CreateIgamingChargebackDeductionFromAffiliateCommissionBody,
	type ListIgamingChargebackDeductionFromAffiliateCommissionResponse,
	type IgamingChargebackDeductionFromAffiliateCommissionRow,
} from "./api";

export function useIgamingChargebackDeductionFromAffiliateCommissionList(): UseQueryResult<ListIgamingChargebackDeductionFromAffiliateCommissionResponse, Error> {
	return useQuery({
		queryKey: igamingChargebackDeductionFromAffiliateCommissionQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingChargebackDeductionFromAffiliateCommissionCreate(): UseMutationResult<IgamingChargebackDeductionFromAffiliateCommissionRow, Error, CreateIgamingChargebackDeductionFromAffiliateCommissionBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingChargebackDeductionFromAffiliateCommissionQueryKeys.all });
		},
	});
}

export function useIgamingChargebackDeductionFromAffiliateCommissionDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingChargebackDeductionFromAffiliateCommissionQueryKeys.all });
		},
	});
}
